export const REQUEST_REVIEW_LIST = 'REQUEST_REVIEW_LIST'
export const REQUEST_REVIEW_LIST_FOR_CAMPAIGN = 'REQUEST_REVIEW_LIST_FOR_CAMPAIGN'